export default __webpack_public_path__ + "static/media/fresto-black-logo.1c963400.svg";